<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation`">创新创业</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/innovation/mentor-list`">双创导师</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content mentor-content" v-loading="loading">
        <div class="card">
          <div class="avatar">
            <img @error="imgError" class="avatar_img" :src="data.Photo" :alt="data.Name" />
          </div>
          <div class="right">
            <h3>{{ data.Name }}</h3>
            <p>
              <span>导师类型：{{ data.Type | typeFilter }}</span>
              <!-- <span>导师类型：{{ data.Type }}</span> -->
              <!-- <span>职称：{{ data.ProfessionalTitle }}</span> -->
              <!-- <span>专业：{{ data.Major }}</span> -->
            </p>
          </div>
        </div>
        <div class="content-wrap">
          <column-header2 :data="{ name: '个人简介' }"></column-header2>
          <div class="content">{{ data.Introduce }}</div>
          <!-- <column-header2 :data="{ name: '获得证书' }"></column-header2>
          <div class="content">{{ data.Certificate }}</div>
          <column-header2 :data="{ name: '获奖情况' }"></column-header2>
          <div class="content">{{ data.Reward }}</div> -->
          <column-header2 :data="{ name: '双创项目' }"></column-header2>
          <SCCard v-for="item in list" :data="item" :key="item.id"></SCCard>
          <el-pagination v-if="total > listQuery.pageSize" class="g-pagination" background layout="prev, pager, next" :current-page="listQuery.pageIndex" :page-size="listQuery.pageSize" :total="total" @current-change="handleIndexChange"></el-pagination>
          <!-- <div class="content">{{ data.Project }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTutorDetail, getTutorPorject } from "api/innovation";
import SCCard from "../components/SCCard";
import ColumnHeader from "_c/ColumnHeader2";
export default {
  name: "TutorDetail",
  components: {
    SCCard,
    [ColumnHeader.name]: ColumnHeader
  },

  filters: {
    typeFilter(val) {
      if (val == "SchoolTutor") {
        return "院校导师";
      } else {
        return "企业导师";
      }
    }
  },
  data() {
    return {
      loading: false,
      data: {},
      listQuery: {
        pageSize: 4,
        pageIndex: 1,
        tutor: this.$route.params.id
      },
      list: null,
      total: 0
    };
  },
  created() {
    this.loadData();
    this.initialize();
  },

  methods: {
    loadData() {
      this.loading = true;
      getTutorDetail(this.listQuery.tutor)
        .then(res => {
          this.data = res.Result.Data || {};
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    initialize() {
      this.loading = true;
      getTutorPorject(this.listQuery)
        .then(res => {
          console.log(res);
          this.loading = false;
          this.list = res.Result.Data;
          this.total = res.Result.TotalCounts;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    handleIndexChange(index) {
      this.listQuery.pageIndex = index;
      this.initialize();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  .mentor-content {
    padding: 0 0 40px 0;
    .card {
      background: url(~assets/img/feature/watermarker.png) no-repeat #5463a4 95%
        top;
      background-size: 170px auto;
      border-radius: 8px 8px 0 0;
      color: #fff;
      height: 102px;
      padding: 16px 40px;
      display: flex;
      align-items: center;
      .avatar {
        width: 104px;
        height: 104px;
        margin-right: 24px;
        .avatar_img {
          border-radius: 52px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h3 {
          font-size: 20px;
          font-weight: 500;
          padding-bottom: 8px;
        }
        p {
          width: 760px;
          display: flex;
          flex-wrap: wrap;
          line-height: 22px;
          span {
            width: 33%;
          }
        }
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
    .content-wrap {
      margin: 0 168px;
    }
  }
}
</style>
